﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcGridFilter from '@mescius/wijmo.grid.filter';
var WjFlexGridFilterBehavior = /** @class */ (function (_super) {
    __extends(WjFlexGridFilterBehavior, _super);
    function WjFlexGridFilterBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexGridFilterBehavior.tag = 'wj-flex-grid-filter';
    WjFlexGridFilterBehavior.parentInCtor = true;
    WjFlexGridFilterBehavior.props = [
        'showFilterIcons',
        'showSortButtons',
        'defaultFilterType',
        'exclusiveValueSearch',
        'filterColumns',
        'reApplyFilterOnUpdate',
        'showIncludeSelection'
    ];
    WjFlexGridFilterBehavior.events = [
        'initialized',
        'editingFilter',
        'filterChanging',
        'filterChanged',
        'filterApplied'
    ];
    WjFlexGridFilterBehavior.classCtor = function () { return wjcGridFilter.FlexGridFilter; };
    return WjFlexGridFilterBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.filter.FlexGridFilter} class.
 *
 * The <b>wj-flex-grid-filter</b> component should be contained in
 * a {@link wijmo.vue2.grid.WjFlexGrid} component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.filter.FlexGridFilter} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 *
 * The example below shows how to instantiate and initialize a
 * {@link wijmo.grid.filter.FlexGridFilter} control with a filter using Vue markup:
 *
 * <pre>&lt;wj-flex-grid
 *   :items-source="data"&gt;
 *   &lt;wj-flex-grid-filter&gt;&lt;/wj-flex-grid-filter&gt;
 * &lt;/wj-flex-grid&gt;</pre>
 */
export var WjFlexGridFilter = WjFlexGridFilterBehavior.register();
function registerV3WjFlexGridFilter(app) {
    app.component(WjFlexGridFilterBehavior.tag, WjFlexGridFilter);
}
export function registerGridFilter(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexGridFilter(app);
    }
}
